import { render, staticRenderFns } from "./PLanPackItem.vue?vue&type=template&id=38f2b108&scoped=true&"
import script from "./PLanPackItem.vue?vue&type=script&lang=js&"
export * from "./PLanPackItem.vue?vue&type=script&lang=js&"
import style0 from "./PLanPackItem.vue?vue&type=style&index=0&id=38f2b108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2b108",
  null
  
)

export default component.exports